import './plugins/docReady';

import 'lazysizes';

import './plugins/formValidation/formValidation.css';
import './plugins/formValidation/formValidation';
import {initRecaptcha} from "./plugins/recaptcha";

import './mobile-menu';

((
    ($) => {
        if ($(window).innerWidth() > 768) {
            $('.main-menu-list li').hover(function () {
                let counter = 0;
                const children = $(this).find('>ul>li');
                children.each(function (index, child) {
                    $(child).css('animation-delay', counter + 's');
                    counter = counter + 0.1;
                })
            });
        }

        function stickyMenu() {
            const header = $("#header");
            header.toggleClass('sticky', $(window).scrollTop() > header.height());
        }

        stickyMenu();

        const UpBtn = $('#upBtn');

        function toTop() {
            if ($(window).scrollTop() > 300) {
                UpBtn.addClass('show');
            } else {
                UpBtn.removeClass('show');
            }
        }

        UpBtn.on('click', function (e) {
            e.preventDefault();
            $('html, body').stop().animate({scrollTop: 0}, 300);
        });

        $(window).on('scroll', function () {
            toTop();
            stickyMenu();
        });

        toTop();

        function statisticsCounter() {
            let targets = $('.statistics');

            if (targets.length) {
                let options = {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.5
                };

                let observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (!$(entry.target).hasClass('activated')) {
                                $(entry.target).addClass('activated');
                                if ($(entry.target).hasClass('statistics')) {
                                    const counts = $(entry.target).find('.count');
                                    counts.each(count => {
                                        $(counts[count]).prop('Counter', 0).animate({
                                            Counter: $(counts[count]).text()
                                        }, {
                                            duration: 2500,
                                            easing: 'swing',
                                            step: (now) => {
                                                $(counts[count]).text(Math.ceil(now));
                                            }
                                        });
                                    });
                                }
                            }
                        }
                    });
                }, options);

                targets.each(target => {
                    observer.observe(targets[target]);
                });
            }
        }

        statisticsCounter();
    }
)
(jQuery));

document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});

docReady(() => {
    let _headerHeight = 130;
    let _options = {
        checkRequired: true,
        scrollToFirstError: true,
        scrollMargin: _headerHeight,
        showErrorGeneralMsg: false,
        requiredMsg: application.translations.required_field,
        emailValidationMsg: 'Invalid email address!',
        beforeAjaxCallBack: function (_form) {
        }
    };

    if ($('.validate-form.no-empty')) {
        let _new_option = {
            emptyFieldsOnSuccess: false
        }
        _options = {..._options, ..._new_option};
    }

    $('.validate-form').validateForm(_options);

    const _loadFormCaptcha = function (_form) {
        let _captcha = _form.find('.g-recaptcha');
        if (_captcha.length && typeof grecaptcha !== 'undefined') {
            if (typeof _captcha.attr('data-id') === 'undefined') {
                setTimeout(function () {
                    let widgetId = grecaptcha.render(_captcha[0], {
                        'sitekey': window.application.services.gcaptcha.site_key
                    });
                    _captcha.attr('data-id', widgetId);
                }, 1000);
            }
        }
    };

    $('form').each((_index, _form) => {
        _form = $(_form);
        _form.find('input, select, textarea').on('focus', function () {
            if (!_form.is(':visible')) {
                return;
            }
            initRecaptcha()
                .then(() => {
                    _loadFormCaptcha(_form);
                }).catch((err) => {
            });
        });
        _form.find('button[type=submit]').on('click', function () {
            if (!_form.is(':visible')) {
                return;
            }
            initRecaptcha()
                .then(() => {
                    _loadFormCaptcha(_form);
                }).catch((err) => {
            });
        });
    });

    let _lottie_loaded = false;
    let _page_loaded = false;
    if (!_page_loaded) {
        $('html').on('mousemove click touchstart touchmove', function (e) {
            if (!_lottie_loaded) {
                const _url = application.lottie_url;
                var lottieScript = document.createElement('script');
                lottieScript.setAttribute('src', _url);
                lottieScript.setAttribute('async', 'async');
                document.head.appendChild(lottieScript);
                _lottie_loaded = true;
            }

            _page_loaded = true;
        });
    }

    const loadScript = function (_url, onLoadCallback) {
        return new Promise((resolve, reject) => {
            var accessibility = document.createElement('script');
            accessibility.setAttribute('src', _url);
            accessibility.setAttribute('async', 'async');
            document.body.appendChild(accessibility);
            if (typeof onLoadCallback === 'function') {
                accessibility.onload = function () {
                    onLoadCallback();
                    resolve();
                }
            } else {
                resolve();
            }
        });
    }

    let accessibilityLoaded = false;

    const loadAccessibilityTool = function () {
        if (accessibilityLoaded) {
            return;
        }

        accessibilityLoaded = true;
        loadScript(window.application.accessibility_url).then(() => {
            $('.side-menu-accessibility').addClass('show');

        });

    };
    $('html').on('mousemove click touchstart touchmove', function (e) {
        loadAccessibilityTool();
    });

    if (parseInt(localStorage.getItem('accessibility-init'), 10) === 1) {
        loadAccessibilityTool();
    }
});